import(/* webpackMode: "eager" */ "/opt/build/repo/app/data-layers/page.tsx");
